import { convert } from "@/libs/units";
import type { NumericPoint } from "@incytestudios/ddv";
import { isFinitePoint, isNaturalPoint } from "../_common";
import type { DataSetWithOperatingPoint, SinglePumpChartContext } from "..";

// We're really only charing the operating point instead of a line
// across flow rate. This was kept in case they want to see a line again
const getNPSHAPoints = (
  context: SinglePumpChartContext
): {
  convertedPoints: NumericPoint[];
  convertedOperatingPoint: NumericPoint;
} => {
  const {
    hypotheticals: { hypotheticalFlowRates },
    liquidFlowRateSTBD,
    baseXUnit,
    targetXUnit,
    baseNpshYUnit,
    targetNpshYUnit,
    npsha
  } = context;
  const originalPoints = hypotheticalFlowRates.map<NumericPoint>(
    flowRateStbD => {
      return {
        x: flowRateStbD,
        y: npsha || 0
      };
    }
  );
  const originalOperatingPoint = originalPoints.find(
    point => point.x === liquidFlowRateSTBD
  );
  const convertedOperatingPoint = {
    x: convert(originalOperatingPoint?.x || 0, baseXUnit, targetXUnit),
    y: convert(originalOperatingPoint?.y || 0, baseNpshYUnit, targetNpshYUnit)
  };
  const convertedPoints = originalPoints
    .map(pt => ({
      x: convert(pt.x, baseXUnit, targetXUnit),
      y: convert(pt.y, baseNpshYUnit, targetNpshYUnit)
    }))
    .filter(isFinitePoint)
    .filter(isNaturalPoint);
  return { convertedPoints, convertedOperatingPoint };
};

export const getDataSetNPSHA = (
  context: SinglePumpChartContext
): DataSetWithOperatingPoint => {
  const { targetXUnitLabel, targetNpshYUnitLabel } = context;
  const data = getNPSHAPoints(context);
  const xLabel = `Flow Rate (${targetXUnitLabel})`;
  const yLabel = `Head (${targetNpshYUnitLabel})`;
  return {
    title: "NPSHa",
    xAxisLabel: xLabel,
    yAxisLabel: yLabel,
    points: data.convertedPoints,
    operatingPoint: {
      point: data.convertedOperatingPoint,
      label: "Target NPSHa",
      xLabel,
      yLabel
    }
  };
};
